import React from "react";
import Container from "react-bootstrap/Container";

import Query from "../../components/Query";
import HOME_QUERY from "../../queries/home";

// import {Helmet} from "react-helmet-async";
import Anmelden from "../../components/Content/anmelden";
import Push from "../../components/Push";
import StandorteBlock from "../../components/Content/standorte";
import TeamBlock from "../../components/Home/team";
import LeistungenBlock from "../../components/Home/leistungen";
import FAQBlock from "../../components/Home/faq";
import ReferalBlock from "../../components/Home/referal";
import IntensivekursBlock from "../../components/Home/intensivekurs";

// import { Link } from "react-router-dom";

const Home = () => {
  return (
    <Query query={HOME_QUERY} id={null}>
      {({ data: { home } }) => {
        return (
          <>
            {/* <Helmet>
                <title>{home.data.attributes.seo.metaTitle}</title>
                <meta name="description" content={home.data.attributes.seo.metaDescription} />
                <meta name="keywords" content={home.data.attributes.seo.keywords} />
                <link rel="canonical" href={home.data.attributes.seo.canonicalURL} />
                <meta property="og:title" content={home.data.attributes.seo.metaTitle} />
                <meta property="og:description" content={home.data.attributes.seo.metaDescription} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={home.data.attributes.seo.canonicalURL} />
                <meta property="og:image" content={process.env.REACT_APP_BACKEND_URL + home.data.attributes.seo.metaImage.data.attributes.url} />
            </Helmet> */}
            <header className="header">
              <Container fluid className="h-100 position-relative">
                <h1
                  className="header_title text-center text-lg-start"
                  data-aos="fade-right"
                  data-aos-offset="-100"
                >
                  <p>HIER BEGINNT</p>
                  <div></div>
                  <p>DEIN ABENTEUER!</p>
                </h1>
                <div
                  className="header_btnAbsolute"
                  data-aos="fade-up"
                  data-aos-offset="-100"
                >
                  <Anmelden btn="btn btn__fill btn__fill_primary"></Anmelden>
                </div>
              </Container>
            </header>
            <IntensivekursBlock />
            <ReferalBlock
              title={home.data.attributes.referal.title}
              desc={home.data.attributes.referal.descr}
              img={home.data.attributes.referal.image.data.attributes}
            />
            <LeistungenBlock />
            <TeamBlock />
            <StandorteBlock
              title={"Weitere<br/>Standorte"}
              description={
                "Besuchen Sie unsere Fahrschulen in Bergedorf, HafenCity und Geesthacht! Genießen Sie hochwertigen Fahrunterricht und professionelle Unterstützung an jedem Standort."
              }
            />
            <FAQBlock />
            <Push></Push>
          </>
        );
      }}
    </Query>
  );
};

export default Home;
